export default {
    methods: {
        getHighlightsLeague (league, highlights) {
            return highlights.find(category => {
                return category.id === 'sports'
            })
                .children.find(highlightsLeague => {
                    return highlightsLeague.name.toLowerCase() === league.toLowerCase()
                })
        },
        isPerformerInHighlightsLeague (performerId, highlightsLeague) {
            return highlightsLeague.some(highlightsLeaguePerformer => {
                return performerId === this.getHighlightsPerformerId(highlightsLeaguePerformer)
            })
        },
        getHighlightsPerformerId (hightlightsPerformerObject) {
            return Number(hightlightsPerformerObject.slug.split('/').splice(-1)[0])
        },
        mapTeamColors (nearbyPerformers, highlights, league) {
            const highlightTeamsInLeague = this.getHighlightsLeague(league, highlights).children

            const nearbyPerformersInHighlightsLeague = nearbyPerformers.filter(nearbyPerformer => {
                return this.isPerformerInHighlightsLeague(nearbyPerformer.id, highlightTeamsInLeague)
            })

            nearbyPerformersInHighlightsLeague.forEach(performer => {
                const mappedHighlightsTeam = highlightTeamsInLeague.find(leagueTeam => {
                    return this.getHighlightsPerformerId(leagueTeam) === performer.id
                })

                performer.primaryColor = mappedHighlightsTeam.primaryColor
                performer.secondaryColor = mappedHighlightsTeam.secondaryColor
            })
            return nearbyPerformersInHighlightsLeague
        }
    }
}
